<div *ngIf="antennaModel != undefined && editModeAntennaName != null" class="modal active">
    <div class="modal__container modal__container--sm">
        <div class="fields">
            <h2 *ngIf="editMode()">Edit Antenna Model</h2>
            <h2 *ngIf="!editMode()">Add Antenna Model</h2>
            <div class="close" (click)="close()"><img src="/assets/img/close-white.svg" alt="" /></div>
            <div class="fields__container">
                <form autocomplete="off"  name="addAntennaModelForm" #ngForm="ngForm" id="addAntennaModelForm" class="active">
                    <div class="fields__block">
                        <div class="fields__block__section">
                            <div class="input-fields">
                                <div>
                                    <label for="">Antenna Model</label>
                                    <input id="antennaModelId" required="true" name="antennaName"
                                    [(ngModel)]="antennaModel.modelName"
                                    alphaNumeric
                                    maxlength="20"
                                    minlength="1"
                                    #antennaName="ngModel"/>
                                    <span class="error" *ngIf="(antennaName.dirty || antennaName.touched) && antennaName.errors?.nonAlphaNumeric">
                                        Only alphanumeric characters, hyphens and underscores are allowed.
                                    </span>
                                    <span class="error" *ngIf="nameExists()">
                                        Model Name already exists. Please choose another one.
                                    </span>
                                </div>
                                <div>
                                  <label for="">Antenna Pattern File</label>
                                  <input
                                  id="AntennaFileId" 
                                  name="AntennaFileName"
                                  style="padding-left: 0px;"
                                  maxlength="300"
                                  type="file"
                                  (change)="saveFile($event)"
                                  [accept]="importFormat.fileExtension"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="fields__btn">
                        <button type="submit" [ngClass]="ngForm.form.valid && fileIsUploaded() ? 'blue' : 'gray'" 
                        (click)="saveButton()" [disabled]="!ngForm.form.valid || nameExists()">
                            Save
                        </button>
                        <button type="button" class="gray" (click)="close()">Cancel</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
  </div>
  